import { FC } from 'react';
import { ReactComponent as DownloadIcon } from '../../assets/download.svg';
import { Tooltip } from '../Tooltip/Tooltip';

type DownloadButtonProps = {
  onClick: () => void;
  title?: string;
  extraClassNames?: string;
};

export const DownloadButton: FC<DownloadButtonProps> = ({
  title = 'Download',
  onClick,
  extraClassNames = '',
}) => {
  return (
    <div className={`flex justify-end h-12 items-start ${extraClassNames}`}>
      <Tooltip title={title}>
        <div
          className={`cursor-pointer border rounded-[0.8rem] group bg-white 
                      transition-all -pt-4 w-[2.9rem] flex items-center justify-center
                      hover:border-gray-400 h-[2.9rem]`}
          onClick={onClick}
        >
          <DownloadIcon className="transition-all fill-black group-hover:fill-white hover:fill-black mr-1 -mt-1" />
        </div>
      </Tooltip>
    </div>
  );
};
